import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {host} from '../../function/api'

const initialState = {
    archives:[],
    loading: false,
    success: false,
    status: false,
    message: '',
    errorTitle: '',
    rahpardaznetLoading: false,
    rahpardaznetMessage: "",
    rahpardaznetSuccess: false,
}

export const archiveManagmentStore = createAsyncThunk(
    'archive/managment/store',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}storePermission`,
                data: data,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'Access-Control-Allow-Origin': "*",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data

        } catch(error) {
            return thunkAPI.rejectWithValue(error)
        }
    }
);
export const fetchArchiveUser = createAsyncThunk(
    'fetch/archiveUserPermission',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}store/user`,
                data: data,
                headers:{
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
const archiveManagmentSlice = createSlice({
    name: 'archiveManagment',
    initialState,
    reducers: {

    },
    extraReducers: {
        [archiveManagmentStore.fulfilled]: (state, {payload}) => {
            state.rahpardaznetLoading = false
            state.rahpardaznetSuccess = true
            state.rahpardaznetMessage = 'سطح دسترسی با موفقیت بروزرسانی شد.'
        },
        [archiveManagmentStore.pending] : (state) => {
            state.rahpardaznetLoading = true    
            state.rahpardaznetSuccess = false
            state.rahpardaznetMessage = ""
        },
        [archiveManagmentStore.rejected]: (state, {payload}) => {
            state.rahpardaznetLoading = false
            state.rahpardaznetSuccess = false
            state.rahpardaznetMessage = payload.response.data.message
            // if(payload.response.data.error) {
            //     state.errorTitle = payload.response.data.error.title
            //     state.errorArchives = payload.response.data.error.store_id
            // }else if(payload.response.data.message) {
            //     state.message = payload.response.data.message
            // }
            
        },
        [fetchArchiveUser.fulfilled]: (state, action) => {
            state.loading = false
            state.success = true
            state.status = action.payload.status
            state.archives = action.payload.data
        },
        [fetchArchiveUser.pending]: (state) => {
            state.loading = true
            state.success = false
            state.archives = []
        },
        [fetchArchiveUser.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            state.status = payload.status
            if(payload.response.data.error){
                state.errorProfile = payload.response.data.errorProfile
                state.errorPermission = payload.response.data.permission
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
});

export const {} = archiveManagmentSlice.actions;
export default archiveManagmentSlice.reducer;